import { Component, OnInit, Input } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { TranslateLanguage } from "../../shared/model/translate-language.model";

import { UrlUtil } from "../../shared/utils/url.util";
import { LocalStorageUtil } from "../../shared/utils/local-storage.util";
import { DataStoreService } from "../../core/services/data-store.service";
import { Decision, Pathway } from "projects/shared-lib/src/public-api";
import { CategoryType } from "../../shared/constant/category-type.constants";
import { ActivatedRoute } from "@angular/router";

@Component({
  selector: "app-mobile-guideline",
  templateUrl: "./guideline.component.html",
  styleUrls: ["./guideline.component.css"],
})
export class GuidelineComponent implements OnInit {
  @Input() guideline: Decision;
  @Input() languages: TranslateLanguage[];

  private userTypeName: string;

  constructor(
    public translateService: TranslateService,
    private urlUtil: UrlUtil,
    private localStorageUtil: LocalStorageUtil,
    public dataStoreService: DataStoreService,
    private activatedRoute: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.userTypeName = this.activatedRoute.snapshot.params["category"];
  }

  getNameDescriptionBasedOnCategory(): Pathway {
    if (this.guideline.categoryId == +CategoryType.EDU_FAMILY) {
      if (this.guideline.pathways.length == 1)
        return this.guideline.pathways[0];
    }
    return null;
  }

  getName(): string {
    var pathway = this.getNameDescriptionBasedOnCategory();
    if (pathway == null) return this.guideline.name;
    return pathway.name;
  }

  getDescription(): string {
    var pathway = this.getNameDescriptionBasedOnCategory();
    if (pathway == null) return this.guideline.description;
    return pathway.description;
  }

  switchLang(languageCode: string) {
    const langCode = languageCode.toLowerCase();
    this.translateService.resetLang(langCode);
    this.translateService.use(langCode);
    this.dataStoreService.setCurrentGuidelines(langCode);
    this.localStorageUtil.saveLanguage(this.userTypeName, langCode);
    this.urlUtil.updateLangParam(langCode);
  }
}
